<template>
  <v-menu activator="parent" location="bottom" offset="10">
    <v-list
      style="border-radius: 14px; background-color: #f2f3fb; padding: 0px"
    >
      <v-list-item style="padding: 0">
        <v-list-item-title>
          <button class="lesson-share-item" @click="copyLink">
            <img src="/images/icon/mdi-copy.svg" alt="Copy" />
            <span>Copy Link</span>
            <span v-if="showCopiedMessage" class="copied-feedback">
              <span class="checkmark">✓</span>
              Copied!
            </span>
          </button>
        </v-list-item-title>
        <v-divider></v-divider>
      </v-list-item>
      <v-list-item style="padding: 0">
        <v-list-item-title>
          <button class="lesson-share-item" @click="shareOnTwitter">
            <img src="/images/icon/mdi-x.svg" alt="Share on Twitter" />
            <span>Share on Twitter</span>
          </button>
        </v-list-item-title>
        <v-divider></v-divider>
      </v-list-item>
      <v-list-item style="padding: 0">
        <v-list-item-title>
          <button class="lesson-share-item" @click="shareOnLinkedIn">
            <img src="/images/icon/mdi-linkedin.svg" alt="Share on LinkedIn" />
            <span>Share on LinkedIn</span>
          </button>
        </v-list-item-title>
        <v-divider></v-divider>
      </v-list-item>
      <v-list-item style="padding: 0">
        <v-list-item-title>
          <button class="lesson-share-item" @click="shareOnFacebook">
            <img src="/images/icon/mdi-facebook.svg" alt="Share on Facebook" />
            <span>Share on Facebook</span>
          </button>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { ref, inject } from "vue";

const showCopiedMessage = ref(false);
const notify = inject("notify");
const callToActionText = "Check out this awesome lesson!";

const copyLink = async () => {
  try {
    // Using a more direct approach for clipboard access
    const currentUrl = window.location.href;
    await navigator.clipboard.writeText(currentUrl);

    notify.success("Link copied to clipboard", "Success");
  } catch (err) {
    console.error("Failed to copy: ", err);
    notify.error(
      "Failed to copy link. Please try again or copy manually.",
      "Error"
    );
  }
};

const shareOnTwitter = () => {
  const url = window.location.href;
  const text = encodeURIComponent(callToActionText);
  const twitterUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
  window.open(twitterUrl, "_blank");
};

const shareOnLinkedIn = () => {
  const url = window.location.href;
  const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
  window.open(linkedInUrl, "_blank");
};

const shareOnFacebook = () => {
  const url = window.location.href;

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&title=${encodeURIComponent(
    callToActionText
  )}`;
  console.log(facebookUrl);
  window.open(facebookUrl, "_blank");
};
</script>

<style scoped>
.lesson-share-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 80px 20px 20px;
  color: var(--primary-blue);
  position: relative; /* For positioning the copied message */
  cursor: pointer;
  white-space: nowrap;
}

.copied-feedback {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #4caf50; /* Brighter green for better visibility */
  font-size: 0.9em;
  font-weight: bold;
  margin-left: 10px;
  background-color: rgba(76, 175, 80, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  position: absolute;
  right: 10px;
  animation: fadeIn 0.3s ease-in-out;
}

.checkmark {
  font-weight: bold;
  font-size: 1.1em;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
